import React from 'react';
import { Button, TableCell, TableRow } from '@insurancemenu/imenu-components-lib';
import { InfoButton, Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import clsx from 'clsx';
import { useRootStore } from 'store/rootStore';
import { Policy } from 'types/policyService';
import { GenerationStepTitle } from 'store/ui-stores/files-tracking/policyDashboardStore';
import { EnrollmentType } from 'types/enrollmentService';
import { createStyles } from './styles';

interface PolicyTableRowProps {
  file: Policy;
}

const PolicyTableRow = ({ file }: PolicyTableRowProps): JSX.Element => {
  const classes = createStyles();
  const { enrollmentPeriod, agency, group, creationDate, generationStep } = file;
  const {
    policyDashboardStore: { openModal },
  } = useRootStore();

  const openUpdateStepModal = (): void => {
    openModal(file, 'UPDATE_STEP');
  };

  const openShowInfoModal = (): void => {
    openModal(file, 'SHOW_INFO');
  };

  return (
    <TableRow className={classes.tableRow}>
      {/* Sponsor Id */}
      <TableCell
        className={clsx(classes.tableCell, enrollmentPeriod.type === EnrollmentType.NEW_SALE && classes.newSaleCell)}
      >
        {enrollmentPeriod.domainId}
      </TableCell>
      {/* Group Name */}
      <TableCell className={classes.tableCell}>{group.name}</TableCell>
      {/* Agency Name */}
      <TableCell className={classes.tableCell}>{agency.name}</TableCell>
      {/* Effective Date */}
      <TableCell className={classes.tableCell}>
        {enrollmentPeriod.effectiveDate ? normDateToShortAmericanDate(enrollmentPeriod.effectiveDate) : ''}
      </TableCell>
      {/* Creation Date */}
      <TableCell className={classes.tableCell}>
        {creationDate ? normDateToShortAmericanDate(creationDate) : ''}
      </TableCell>
      {/* Generation Step  */}
      <TableCell className={classes.tableCell}>{GenerationStepTitle[generationStep]}</TableCell>
      <TableCell className={clsx(classes.tableCell, classes.buttonCell)}>
        <Button
          type="text"
          leftIconProp={<Edit />}
          color="primary"
          onClick={openUpdateStepModal}
          className={classes.actionButton}
        >
          Update Step
        </Button>
      </TableCell>
      <TableCell className={clsx(classes.tableCell, classes.buttonCell)}>
        <Button
          type="text"
          leftIconProp={<InfoButton />}
          color="primary"
          onClick={openShowInfoModal}
          className={classes.actionButton}
        >
          Full Info
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default PolicyTableRow;
